class TabsComponent extends HTMLElement {
  constructor() {
    super()
    this.container = this.querySelector('#tabs-container')
    this.tabButtons = this.querySelectorAll('.tab-button')
    this.tabContents = this.querySelectorAll('.tab-content')

    this.options = {
      activeButtonClass: 'border-black',
      inactiveButtonClass: 'border-transparent',
      defaultTabIndex: 0
    }

    this.init()
  }

  init() {
    this.bindEvents()

    if (this.tabButtons.length) {
      this.activateTab(this.options.defaultTabIndex)
    }

    this.applyRichTextStyles()
  }

  bindEvents() {
    this.tabButtons.forEach((button, index) => {
      button.addEventListener('click', () => this.activateTab(index))
    })
  }

  activateTab(index) {
    this.tabButtons.forEach(btn => {
      btn.classList.remove(this.options.activeButtonClass)
      btn.classList.add(this.options.inactiveButtonClass)
    })

    this.tabButtons[index].classList.remove(this.options.inactiveButtonClass)
    this.tabButtons[index].classList.add(this.options.activeButtonClass)

    this.tabContents.forEach(content => {
      content.classList.add('hidden')
    })

    this.tabContents[index].classList.remove('hidden')

    const bgColor = this.tabButtons[index].getAttribute('data-bg-color')

    if (bgColor) {
      this.container.style.backgroundColor = bgColor
    }
  }

  applyRichTextStyles() {
    const richTextContainers = document.querySelectorAll('.richtext-container')

    richTextContainers.forEach(container => {
      container.querySelectorAll('strong').forEach(strong => {
        strong.classList.add('text-grey-900', 'font-[500]', 'leading-[20px]')
      })
      container.querySelectorAll(':not(strong)').forEach(element => {
        if (!element.classList.contains('text-grey-900')) {
          element.classList.add('text-grey-700')
        }
      })
    })
  }
}

customElements.define('tabs-container', TabsComponent)
